import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { AdUnitForProductTable, AdUnitSortBy } from '../../types'
import { AdUnitForProductTableDTO, AdUnitSortByDTO } from './types'

type From = AdUnitForProductTableDTO
type To = AdUnitForProductTable

export const adUnitForProductTableFromDTO = (from: From): To =>
  mapDTO<From, To>({
    from,
  }).transform((adUnitDTO: From): To => {
    const { divId, name, outOfPage, updatedAt, viewabilityToolsEnabled } = adUnitDTO

    return {
      ...adUnitDTO,
      divId: divId || undefined,
      name: name || undefined,
      updatedAt: new Date(updatedAt),
      viewabilityToolsEnabled: outOfPage ? false : viewabilityToolsEnabled,
    }
  })

export const sortToDTO = (sort: SortInput<AdUnitSortBy>): SortInput<AdUnitSortByDTO> => {
  const { by } = sort

  if (by === 'name') {
    return { ...sort, by: 'adUnitName' }
  } else {
    return { ...sort, by }
  }
}
